import { memo } from "react"
import { useEvent } from "../context/eventContext"
import { differenceInMonths, format } from "date-fns"
import { myFormat, myTimestampToDate, propComparator, propComparatorDate } from "../utils/ui_utils"
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    Tooltip,
} from '@mui/material';
import { globalstyles } from '../lib/definitions';
import { AddBox, Backspace, Block, Check, CheckBox, CheckBoxOutlineBlank, Close, Error, FactCheck, Info, LibraryAddCheck, List, MilitaryTech, Padding, PanTool, PictureAsPdf, PlayArrow, Save, Stop, ViewList, Warning } from '@mui/icons-material';
import { CowtypeBadge } from "../components/CowtypeButton";
import { Text } from "@react-pdf/renderer";
export const common_data_entry = [
    { id: 'name', label: 'Nome', import_id: 'nome' },
    { id: 'coproperty', label: 'Comproprietà', import_id: 'comprop' },
    { id: 'serial', label: 'Matricola', import_id: 'matricola' },
    { label: 'Data di nascita', id: 'birthdate', type: 'date', import_id: 'datanascita' },
    { label: 'Numero parti', id: 'birth', type: 'number', min_value: 0, import_id: 'n_parti' },
    { label: 'Data ultimo parto', id: 'last_birthdate', type: 'date', import_id: 'ultimo_parto', conditional: { param: 'birth', min_value: 1 } },
    { id: 'cross_father', label: 'Cross padre', import_id: 'cross_padre' },
    { id: 'cross_grandfather', label: 'Cross nonno', import_id: 'cross_nonno' },
    { id: 'cross_grandgrandfather', label: 'Cross bisnonno', import_id: 'cross_nonnobis' },
]
export const other_data_entry = [
    { id: 'cow_type', label: 'tipologia', import_id: 'red', type: 'switch' },
    { id: 'breed', label: 'razza', type: 'switch' },
    { id: 'cdaua_cowman', label: 'Codice AUA allevatore (azienda di nascita)', import_id: 'cdaua_allevatore' },
    { id: 'catalog_id', label: 'Codice catalogo' },
    { id: 'not_present', label: 'Assente' },
    { id: 'property', label: 'Proprietà' },
    { id: 'cowman', label: 'Allevatore' },
    { id: 'cow_code', label: 'mycode' },
    //   { id: 'property', label: 'Ragione sociale azienda', import_id: 'azienda' },
    { id: 'cdaua', label: 'Codice  AUA azienda', import_id: 'cdaua' },
    { id: 'import_category_id', label: 'Categoria importazione', import_id: 'categoria_ins' },


]
export const advance_data_entry = [
    { label: 'tipo test', id: 'last_exam_type', import_id: 'tipo_test' },
    { label: 'esito esame', id: 'last_exam_result', import_id: 'esito' },
    { label: 'messaggio esame', id: 'last_exam_message', import_id: 'messaggio' },
    { id: 'pft', label: 'Indice pft', import_id: 'pft' },
    { id: 'rank', label: 'Rank', import_id: 'rank' },
    { id: 'kg_protein_index', label: 'Indice Kg proteina', import_id: 'indice_kg_proteina' },
    { id: 'ies', label: 'Indice IES', import_id: 'ies' },
    { id: 'iqj', label: 'Indice IQJ', import_id: 'iqj' },
    { id: 'ics_pr', label: 'Indice ics-pr', import_id: 'ics_pr' },
    { id: 'health_index', label: 'Indice benessere', import_id: 'benessere' },
    { id: 'gg_milk', label: 'giorni lattazione', import_id: 'gg_latt' },
    { id: 'kg_milk', label: 'Kg latte soggetto', import_id: 'kg_latte_soggetto' },
    { id: 'fatperc', label: 'grasso % soggetto', import_id: 'grassoper_soggetto' },
    { id: 'fat_kg', label: 'grasso Kg soggetto', import_id: 'grasso_kg_soggetto' },
    { id: 'proteinperc', label: 'proteina % soggetto', import_id: 'proteinaper_soggetto' },
    { id: 'protein_kg', label: 'proteina Kg soggetto', import_id: 'proteina_kg_soggetto' },
]

export const lifetime_data_entry = [
    { id: 'milk_gg_life', label: 'latte prodotto per giorno di vita', import_id: 'latte_gg_vita_soggetto' },
    { id: 'lf_order', label: 'lifetime ordine di parto', import_id: 'lf_ordine' },
    { id: 'lf_gg', label: 'lifetime giorni di lattazione', import_id: 'lf_gg' },
    { id: 'lf_kg_milk', label: 'latte Kg lifetime', import_id: 'lf_kg_latte' },
    { id: 'lfperc_fat', label: 'grasso % lifetime', import_id: 'lf_pergr' },
    { id: 'lf_kggr', label: 'grasso Kg lifetime', import_id: 'lf_kggr' },
    { id: 'lf_percpt', label: 'proteina % lifetime', import_id: 'lf_perpt' },
    { id: 'lf_kgpt', label: 'proteina Kg lifetime', import_id: 'lf_kgpt' },
]

export const mother_data_entry = [
    { id: 'mad_age', label: 'età madre (mesi)', import_id: 'mad_eta' },
    { id: 'mad_gg', label: 'giorni lattazione (madre)', import_id: 'mad_gg' },
    { id: 'mad_kg_latte', label: ' latte Kg (madre)', import_id: 'mad_kg_latte' },
    { id: 'mad_pergr', label: 'grasso% (madre)', import_id: 'mad_pergr' },
    { id: 'mad_kggr', label: 'grasso Kg (madre)', import_id: 'mad_kggr' },
    { id: 'mad_perpt', label: 'proteina % (madre)', import_id: 'mad_perpt' },
    { id: 'mad_kgpt', label: 'proteina Kg (madre)', import_id: 'mad_kgpt' },
]
export const cow_type_sublist = [
    { id: 'black', label: 'black', color: 'black', label_short: 'bk', color: 'black' },
    { id: 'red', label: 'red', color: 'error', label_short: 'red', color: 'red' }
]

export const cow_race_sublist = [
    { id: '02', label: 'Frisona' },
    { id: '15', label: 'Jersey' },
    { id: '01', label: 'Bruna' }

]

export const getCowLight = (cow, other_cow_params) => {
    let c = {
        id: cow.id,
        serial: cow.serial,
        property: cow.property,
        name: cow.name,
        cow_type: cow.cow_type,
        birthdate: cow.birthdate,
        birth: cow.birth,
    }
    if (cow.last_birthdate) {
        c.last_birthdate = cow.last_birthdate
    }
    if (other_cow_params) {

        for (const p of other_cow_params) {
            if (cow[p]) {

                c[p] = cow[p]
            }
        }

    }
    if (cow.catalog_id) {
        c.catalog_id = cow.catalog_id
    }
    return c
}


export const getCross = (cow) => {
    const separator = " x "
    return (cow.cross_father || " ") + separator + (cow.cross_grandfather || " ") + separator + (cow.cross_grandgrandfather || " ")
}


export const CowCrossPDF = ({ cow, x_style }) => {
    const separator = <Text style={x_style}>x</Text>
    return <Text>{cow.cross_father || " "}{separator}{cow.cross_grandfather || " "}{separator}{cow.cross_grandgrandfather || " "}</Text>
}


export const OneCow = memo(({ cow, btn, showSelect, matchStatus, toggleSelect, is_selected }) => {
    const birthdate = myTimestampToDate(cow.birthdate)
    const { selEvent } = useEvent()
    const ev_date = myTimestampToDate(selEvent.event_start)

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
            {toggleSelect && showSelect && matchStatus === 'pre' &&
                <Grid size={1}>
                    <Button variant={is_selected ? 'contained' : 'outlined'} onClick={() => toggleSelect(cow.id)} size="small" >{is_selected ? <CheckBox /> : <CheckBoxOutlineBlank />}</Button>
                </Grid>
            }
            <Grid size={1} sx={{ paddingLeft: 1, fontWeight: 'bold' }}>
                {cow.catalog_id}
            </Grid>
            <Grid size={matchStatus === 'run' || matchStatus === 'end' ? "grow" : 1} flexDirection={"row"} container>
                <CowtypeBadge cow_type={cow.cow_type} />
                {cow.serial}
            </Grid>
            <Grid size="grow">
                {cow.name}
            </Grid>
            <Grid size="grow">
                {cow.property?.name}
                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>{cow.coproperty}</Box>
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={1}>
                {differenceInMonths(ev_date, birthdate)}
            </Grid>
            <Grid size={1}>
                {format(birthdate, 'dd/MM/yyyy')}
            </Grid>
            <Grid size="grow">
                {btn}
                {cow.from_manual &&
                    <Tooltip arrow title="soggetto inserimento manualmente">
                        <span>
                            <PanTool sx={{ fontSize: '1.1em' }} />
                        </span>
                    </Tooltip>}
            </Grid>
        </Grid>
    )
})



export const CowBirthdate = ({ birthdate, ev_date, show_age }) => {
    const _birthdate = myTimestampToDate(birthdate)
    if (show_age) {
        return (
            birthdate && <>
                {myFormat(_birthdate, 'dd/MM/yyyy')}
                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>
                    {differenceInMonths(ev_date, _birthdate)}
                </Box>
            </>

        )

    } else {
        return (
            birthdate && <>
                {myFormat(_birthdate, 'dd/MM/yyyy')}
            </>

        )

    }

}


export const DynamicOneCow = memo(({ cow, index, btn }) => {
    const birthdate = myTimestampToDate(cow.birthdate)
    const { selEvent } = useEvent()
    const ev_date = myTimestampToDate(selEvent.event_start)
    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
            <Grid size={1} sx={{ fontStyle: 'italic' }}>
                {index + 1}
            </Grid>
            <Grid size={1} sx={{ fontWeight: 'bold' }}>
                {cow.catalog_id}
            </Grid>
            <Grid size={3} >
                {cow.award_source_list?.map((a, k) => (
                    <Grid container key={k} sx={{ fontWeight: 'bold', color: 'blue' }}>
                        <Grid size={6}>
                            {a.match_name}
                        </Grid>
                        <Grid size={3}>
                            {a.award_label}
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            <Grid size={1} flexDirection={"row"} container>
                <CowtypeBadge cow_type={cow.cow_type} />
                {cow.serial}
            </Grid>
            <Grid size={2} >
                {cow.property?.name}
                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>{cow.coproperty}</Box>
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={1}>
                {differenceInMonths(ev_date, birthdate)}
            </Grid>
            <Grid size={1}>
                {format(birthdate, 'dd/MM/yyyy')}
            </Grid>
            <Grid size="grow">
                {btn}
            </Grid>
        </Grid>
    )

})



export const getSummaryData = (gm, cl) => {
    let _data_dict = {}
    let p_list = []
    if (gm !== 'cowlist') {
        for (const cow of cl) {
            let sd = { id: -1, name: '---' }
            if (gm === 'cowman' && cow.cowman && cow.cowman.id) {
                sd = { ...cow.cowman }
            } else if (gm === 'property' && cow.property && cow.property.id) {
                sd = { ...cow.property }
            } else if (gm === 'prov' && cow.property && cow.property.provincia) {
                sd = { id: cow.property.provincia, name: cow.property.provincia }
            }
            if (!_data_dict[sd.id]) {
                _data_dict[sd.id] = {
                    ...sd,
                    cow_list: [],
                }
            }
            let cl = [..._data_dict[sd.id].cow_list]
            cl.push(cow)
            _data_dict[sd.id].cow_list = cl
        }

        for (const g_id in _data_dict) {
            let _g = _data_dict[g_id]
            p_list.push({
                ..._g,
                cow_list: _g.cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id'))
            })
        }
        if (gm === 'prov') {
            p_list = p_list.sort(propComparator("name"))
        } else if (gm === 'cowman') {
            p_list = p_list.sort(propComparator("cdaua_cowman"))
        } else if (gm === 'property') {
            p_list = p_list.sort(propComparator("cdaua"))
        }
    }else {
        p_list = cl
    }

    return p_list
}